import React from 'react';
import {GOOGLE_ANALYTICS_ID, isETicketDomain} from '../../config/config';
import {Helmet} from 'react-helmet';
import {useLocation} from 'react-router-dom';

const Analytics = () => {
    if(process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'development') {
        return null;
    }
    if(isETicketDomain) {
        return null;
    }
    if(isETicketDomain) {
        return null;
    }
    const location = useLocation();

    const excludedPaths = ['/login', '/signUp'];
    const isExcludedPath = excludedPaths.some(path => path.toLowerCase() === location.pathname.toLowerCase()) || location.pathname === '/';

    if(isExcludedPath) {
        return null;
    }

    return (
        <Helmet>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`} />
            <script>
                {`
                  window.dataLayer = window.dataLayer || [];
                  window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
                  gtag('js', new Date());
                  gtag('config', '${GOOGLE_ANALYTICS_ID}');
                  try {
                    var tickchakUser = JSON.parse(localStorage.getItem('user') || 'null');
                    if(tickchakUser && tickchakUser.uid != null) {
                      gtag('set', 'user_properties', { global_user_id: String(tickchakUser.uid) });
                    }
                  } catch (e) {}
                `}
            </script>
        </Helmet>
    );
};

export default Analytics;
